import React, { useState } from 'react';

const HelpWidget = () => {
    const [isOpen, setIsOpen] = useState(false);

    const handleEmailClick = () => {
        window.location.href = 'mailto:projecktocare@gmail.com?subject=Help with Project Submission&body=Hi Projekto Team,%0D%0A%0D%0AI need help with:%0D%0A%0D%0A';
    };

    return (
        <>
            {/* Floating Help Button */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="fixed bottom-6 right-6 bg-blue-500 hover:bg-blue-600 text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg transition-all hover:scale-110 active:scale-95 z-50"
                aria-label="Need Help?"
            >
                {isOpen ? (
                    <span className="material-symbols-outlined text-2xl">close</span>
                ) : (
                    <span className="material-symbols-outlined text-2xl">help</span>
                )}
            </button>

            {/* Help Popup */}
            {isOpen && (
                <div className="fixed bottom-24 right-6 bg-dark-card border border-border-gray rounded-2xl shadow-2xl w-80 z-50 overflow-hidden animate-slide-up">
                    {/* Header */}
                    <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-5">
                        <div className="flex items-center gap-3">
                            <span className="material-symbols-outlined text-white text-3xl">support_agent</span>
                            <div>
                                <h3 className="text-white font-bold text-lg">Need Help?</h3>
                                <p className="text-blue-100 text-sm">We're here for you!</p>
                            </div>
                        </div>
                    </div>

                    {/* Content */}
                    <div className="p-5 space-y-4">
                        <p className="text-gray-300 text-sm leading-relaxed">
                            Having trouble with the form? Our support team is ready to assist you with any questions.
                        </p>

                        {/* Contact Button */}
                        <button
                            onClick={handleEmailClick}
                            className="w-full bg-blue-500 hover:bg-blue-600 text-white rounded-xl py-3 px-4 flex items-center justify-center gap-2 transition-all active:scale-95 font-semibold"
                        >
                            <span className="material-symbols-outlined text-xl">mail</span>
                            Email Support
                        </button>

                        {/* Email Display */}
                        <div className="bg-dark-bg border border-border-gray rounded-xl p-3 flex items-center gap-2">
                            <span className="material-symbols-outlined text-gray-400 text-lg">alternate_email</span>
                            <a
                                href="mailto:projecktocare@gmail.com"
                                className="text-blue-400 hover:text-blue-300 text-sm transition-colors flex-1 truncate"
                            >
                                projecktocare@gmail.com
                            </a>
                        </div>

                        {/* Quick Tips */}
                        <div className="border-t border-border-gray pt-4">
                            <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-2">Quick Tips</p>
                            <ul className="space-y-2 text-gray-300 text-sm">
                                <li className="flex items-start gap-2">
                                    <span className="material-symbols-outlined text-blue-400 text-base mt-0.5">check_circle</span>
                                    <span>Fill all required fields</span>
                                </li>
                                <li className="flex items-start gap-2">
                                    <span className="material-symbols-outlined text-blue-400 text-base mt-0.5">check_circle</span>
                                    <span>Review before payment</span>
                                </li>
                                <li className="flex items-start gap-2">
                                    <span className="material-symbols-outlined text-blue-400 text-base mt-0.5">check_circle</span>
                                    <span>Check email for updates</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}

            {/* Backdrop */}
            {isOpen && (
                <div
                    onClick={() => setIsOpen(false)}
                    className="fixed inset-0 bg-black/20 z-40 backdrop-blur-sm"
                />
            )}

            <style jsx>{`
        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slide-up {
          animation: slide-up 0.3s ease-out;
        }
      `}</style>
        </>
    );
};

export default HelpWidget;
